import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { StoreError } from "./errors";

const TEST_ENV = process.env.NODE_ENV === "test";
const _firebase = TEST_ENV
  ? require("../testing/mock-firebase").default
  : firebase;
export default _firebase as typeof firebase;

if (!TEST_ENV && firebase.apps.length === 0) {
  const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";
  if (useEmulators && !["localhost", "127.0.0.1"].includes(window.location.hostname)) {
    throw new Error("Event rehearsal is available on localhost only.");
  }
  firebase.initializeApp(useEmulators ? {
    apiKey: "demo-event-qa-api-key",
    authDomain: "localhost",
    projectId: "demo-wwsc-event-qa",
    storageBucket: "demo-wwsc-event-qa.appspot.com",
    messagingSenderId: "000000000000",
    appId: "1:000000000000:web:eventqa",
  } : {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  });
  if (useEmulators) {
    firebase.auth().useEmulator("http://127.0.0.1:9197");
    firebase.firestore().useEmulator("127.0.0.1", 8187);
    firebase.functions().useEmulator("127.0.0.1", 5097);
    firebase.storage().useEmulator("127.0.0.1", 9297);
  }
}

export function getCurrentUserInfo(): { uid: string; email: string } {
  const user: firebase.User | null = _firebase.auth()?.currentUser;
  if (!user) {
    throw new StoreError("No current user.");
  }
  const { uid, email } = user;
  if (!(uid && email)) {
    throw new StoreError("No current user.");
  }
  return { uid, email };
}

export const Timestamp = firebase.firestore.Timestamp;
export type DocumentData = firebase.firestore.DocumentData;
export type QuerySnapshot = firebase.firestore.QuerySnapshot;
export type DocumentSnapshot = firebase.firestore.DocumentSnapshot;
export const FieldPath = firebase.firestore.FieldPath;
